import type { RootState } from '@/store'

// Dashboard selectors
export const selectDashboardState = (state: RootState) => state.dashboard.dashboardState
export const selectDashboardLoading = (state: RootState) => state.dashboard.isLoading
export const selectDashboardError = (state: RootState) => state.dashboard.error
export const selectHasDashboard = (state: RootState) => state.dashboard.hasDashboard

// Upload selectors
export const selectSelectedFile = (state: RootState) => state.upload.selectedFile
export const selectIsUploading = (state: RootState) => state.upload.isUploading
export const selectUploadSuccess = (state: RootState) => state.upload.uploadSuccess 
export const selectSessionId = (state: RootState) => state.dashboard.sessionId